import React from 'react';

// External Dependencies
import Table from 'material-ui-next/Table';

// Internal Dependencies
import NinjasTableRows from './ninjas-table-rows';
import NinjasTableHeader from './ninjas-table-header';
import NinjasTableFooter from './ninjas-table-footer';

const tableRootStyle = {
  overflowX: 'auto',
};

const NinjasTable = () => (
  <div style={tableRootStyle}>
    <Table>
      <NinjasTableHeader />
      <NinjasTableRows />
      <NinjasTableFooter />
    </Table>
  </div>
);

export default NinjasTable;



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/ninjas-table.js
 **/